import { getApiAsyn } from "../../services/PostAPI";

const cleanTitle = (title = "") => title.replace(/[\/&]/g, "").trim();

/**
 * Normalizes and extracts permission flags for a menu item.
 */
const getScreenPermissionInfo = (item) => ({
  view: Boolean(item.view),
  create: Boolean(item.createCrud),
  edit: Boolean(item.editCrud),
  title: cleanTitle(item.title || ""),
});

/**
 * Converts a string like "Booking Engine" to "bookingEngineMenu".
 */
const generateCamelCaseMenuKey = (title = "") => {
  const words = title.trim().split(" ");
  if (words.length === 0) return "menu";

  const [firstWord, ...restWords] = words;
  const camelKey =
    firstWord.toLowerCase() +
    restWords
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join("");

  return camelKey + "Menu";
};

/**
 * Fetch and save formatted user menu access in localStorage.
 * Fallbacks to defaultMenuAccess if not matched.
 */
export const getMenuAccess = async (token, userId) => {
  try {
    const res = await getApiAsyn(
      `users/getUserMenuAccess?userId=${userId}`,
      token
    );

    const access = {};
    const menuIdMapping = {}; // Map menu key to menuId for favorites API
    const keyCountMap = {}; // To track duplicate keys

    if (Array.isArray(res)) {
      res.forEach((item) => {
        if (item.title) {
          const baseKey = generateCamelCaseMenuKey(cleanTitle(item.title));
          let key = baseKey;

          if (keyCountMap[baseKey]) {
            key = `${baseKey}${keyCountMap[baseKey] + 1}`;
            keyCountMap[baseKey]++;
          } else {
            keyCountMap[baseKey] = 1;
          }

          access[key] = getScreenPermissionInfo(item);
          
          // Store menuId mapping using the cleaned title as key
          // API returns menuId field, not id
          if (item.menuId) {
            const titleKey = cleanTitle(item.title).toLowerCase();
            menuIdMapping[titleKey] = {
              menuId: item.menuId,
              title: item.title,
              url: item.url || "",
            };
          }
        }
      });
    }

    localStorage.setItem("menuAccess", JSON.stringify(access));
    localStorage.setItem("menuIdMapping", JSON.stringify(menuIdMapping));
  } catch (error) {
    console.error("Failed to get menu access:", error);
  }
};
